import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const BookmarkIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props}>
      <path
        className={`icon--${props.color}`}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 17.981V9.708Q3.25 3.939 4.651 2.589Q6.041 1.25 12 1.25Q17.959 1.25 19.349 2.589Q20.75 3.939 20.75 9.708V17.981Q20.75 21.889 19.581 22.514Q18.02 23.347 14.301 20.597Q13.488 19.996 13.203 19.825Q12.222 19.234 12 19.234Q11.778 19.234 10.797 19.825Q10.512 19.996 9.699 20.597Q5.98 23.347 4.42 22.514Q3.25 21.889 3.25 17.981ZM4.75 17.981Q4.75 20.99 5.126 21.191Q5.851 21.578 8.807 19.391Q9.677 18.748 10.023 18.54Q11.361 17.734 12 17.734Q12.639 17.734 13.977 18.54Q14.323 18.748 15.193 19.391Q18.149 21.578 18.874 21.191Q19.25 20.99 19.25 17.981V9.708Q19.25 4.576 18.308 3.669Q17.354 2.75 12 2.75Q6.646 2.75 5.692 3.669Q4.75 4.576 4.75 9.708Z"
      />
    </IconSvgWrapper>
  );
};

export default BookmarkIcon;
